import React from 'react';
import PropTypes from 'prop-types';
import Headshot, { HeadshotTypes } from '@mlb/react-patterns/components/Headshot/headshot';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { WinnerThumbnailWrapper, WinnerPhoto, WinnerBadge } from '../PlayerOfTheGame.style';
import { resourcePath } from '@gameday/utils/resource-path';
import Image from '@mlb/react-patterns/components/Image/image';
import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton';

export const ACTION = 'action';
const SPOT = HeadshotTypes.SPOTS;
const HEADSHOT_PROPS = {
    [ACTION]: {
        type: ACTION,
        ratio: '2:3',
        rounded: false,
        width: '64px'
    },
    [SPOT]: {
        type: SPOT,
        ratio: '1:1',
        width: '64px'
    }
};

const THREE_X = '3x';
const TWO_X = '2x';
const ONE_X = '1x';
const widthString = {
    [THREE_X]: 'w_192',
    [TWO_X]: 'w_128',
    [ONE_X]: 'w_64'
};
const actionShotOptsPath = (scale) => widthString[scale] + ',f_jpg/';
const getActionShotSrcSet = playerId => {
    return {
        [THREE_X]: resourcePath.get('playerActionShot', { optionsPath: actionShotOptsPath(THREE_X), playerId }),
        [TWO_X]: resourcePath.get('playerActionShot', { optionsPath: actionShotOptsPath(TWO_X), playerId }),
        [ONE_X]: resourcePath.get('playerActionShot', { optionsPath: actionShotOptsPath(ONE_X), playerId })
    };
};
const PhotoComponent = (props) => {
    return (
        props.type === SPOT
            ? (
                <Headshot {...HEADSHOT_PROPS[props.type]} {...props}/>
            )
            : (
                <Image
                    src={resourcePath.get('playerActionShot', { optionsPath: actionShotOptsPath(THREE_X), playerId: props.playerId })}
                    srcset={getActionShotSrcSet(props.playerId)}
                    {...HEADSHOT_PROPS[props.type]} {...props}/>
            )
    );
};
PhotoComponent.propTypes = {
    type: PropTypes.string,
    playerId: PropTypes.string
};

export const WinnerThumbnail = (props) => {
    const {
        winner: {
            hasStory,
            feedId
        },
        isLoadingStories
    } = props;
    const translate = useTranslate();
    const type = hasStory ? ACTION : SPOT;
    const badgeLabel = translate('player_of_the_game', 'Player of the Game');

    return (
        <WinnerThumbnailWrapper>
            <WinnerPhoto type={type}>
                {isLoadingStories
                    ? (
                        <Skeleton height={'64px'} width={'64px'} isCircle/>
                    )
                    : (
                        <PhotoComponent
                            type={type}
                            playerId={feedId}
                        />
                    )
                }
            </WinnerPhoto>
            <WinnerBadge>{badgeLabel}</WinnerBadge>
        </WinnerThumbnailWrapper>
    );
};

WinnerThumbnail.propTypes = {
    winner: PropTypes.object,
    voteLink: PropTypes.string,
    deviceInteraction: PropTypes.object,
    componentName: PropTypes.string,
    isLoadingStories: PropTypes.bool
};
